import React, {useContext} from 'react'
import { useLayoutEffect } from 'react'
import { useState } from 'react'
import {GlobalLangCtx} from '../../App'
import PreviewProjsComp from '../PreviewProjectComp/PreviewProjectComp'
import { extractProjectTitle, extractProjectProps, MakeComponent } from '../../app_utilities/makeComponent'
import "./ProjectComp.css"




const ProjectsComp = () =>{

    const [positionScroll, setPositionScroll] = useState(0)
    const [selLan, setselLan] = useContext(GlobalLangCtx);
    const fLan = require (`../language_app/json_files/lang[${selLan}].json`)
    const [getProj, setGetproj] = useState({proName: "", proId: -1})

    useLayoutEffect(() =>{
        <PreviewProjsComp projectProp={getProj} setParentState={setGetproj} />
    },[getProj.proId])
    
    const {projectsPHP} = require (`../json_archivies/projectsPHP[${selLan}].js`)
    const {projectsJS} = require (`../json_archivies/projectsJS[${selLan}].js`)
    const {projectsReact} = require (`../json_archivies/projectsReact[${selLan}].js`)
    const {projectsVue} = require (`../json_archivies/projectsVue[${selLan}].js`)
    const {projectsNode} = require (`../json_archivies/projectsNode[${selLan}].js`)
    const {projectsLaravel} = require (`../json_archivies/projectsLaravel[${selLan}].js`)

    const phpTitleSection = extractProjectTitle(projectsPHP, setGetproj, "PHP")
    const phpPropsSection = extractProjectProps(projectsPHP, setGetproj, "PHP")

    const JSTitleSection = extractProjectTitle(projectsJS, setGetproj, "JS")
    const JSPropsSection = extractProjectProps(projectsJS, setGetproj, "JS")

    const ReactTitleSection = extractProjectTitle(projectsReact, setGetproj, "React")
    const ReactPropsSection = extractProjectProps(projectsReact, setGetproj, "React")
    
    const NodeTitleSection = extractProjectTitle(projectsNode, setGetproj, "Node")
    const NodePropsSection = extractProjectProps(projectsNode, setGetproj, "Node")
        
    const LaravelTitleSection = extractProjectTitle(projectsLaravel, setGetproj, "Laravel")
    const LaravelPropsSection = extractProjectProps(projectsLaravel, setGetproj, "Laravel")
    
    // const VueTitleSection = extractProjectTitle(projectsVue, setGetproj, "Vue")
    // const VuePropsSection = extractProjectProps(projectsVue, setGetproj, "Vue")
    

    const allProjects = (

        <div className='mainPprojBox'>
        <div className='titleCompnet'>
            <h1 id='projectComp'>
                { fLan.ProjectsSection.title }  
                {/* <div>
                    projectName: { getProj.proName } projectId: { getProj.proId }
                </div> */}
            </h1>
        </div>

        <MakeComponent titleSection={phpTitleSection} propsSection={phpPropsSection}/>
        <MakeComponent titleSection={JSTitleSection} propsSection={JSPropsSection}/>
        <MakeComponent titleSection={ReactTitleSection} propsSection={ReactPropsSection}/>
        <MakeComponent titleSection={LaravelTitleSection} propsSection={LaravelPropsSection}/>
        <MakeComponent titleSection={NodeTitleSection} propsSection={NodePropsSection}/>
        {/* <MakeComponent titleSection={VueTitleSection} propsSection={VuePropsSection}/> */}

        </div>
    )

    const showProject = (getProj.proId !== -1) && <PreviewProjsComp projectProp={getProj} setParentState={setGetproj} />

    // const showProject = (getProj.proId == -1) ? allProjects : <PreviewProjsComp projectProp={getProj} setParentState={setGetproj} />

    return(
        <div>
            {
                allProjects
            }
            {
               showProject 
            }
        </div>
       
    )

}

export default ProjectsComp;